import { render, staticRenderFns } from "./Shopbox.vue?vue&type=template&id=655c06ba&scoped=true&shadow"
import script from "./Shopbox.vue?vue&type=script&lang=js&shadow"
export * from "./Shopbox.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./Shopbox.vue?vue&type=style&index=0&id=655c06ba&scoped=true&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "655c06ba",
  null
  ,true
)

export default component.exports